import React from 'react';

interface IconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

// 返回按钮图标
export const BackIcon: React.FC<IconProps> = ({ width = 30, height = 30, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <path 
      fill="none" 
      stroke="#ff1744" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      strokeWidth="1.5" 
      d="M15 6s-6 4.419-6 6s6 6 6 6" 
      color="#ff1744"
    />
  </svg>
);

// 用户占位符图标
export const UserPlaceholderIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <path fill="#b3b3b3" d="M11.5 2a5.5 5.5 0 1 0 0 11a5.5 5.5 0 0 0 0-11M18 14c-.93 0-1.5.656-1.5 1.249v1h-2v-1C14.5 13.358 16.17 12 18 12s3.5 1.358 3.5 3.249a3.13 3.13 0 0 1-1.027 2.3L19 18.939v.683h-2v-1.546l2.112-1.993c.256-.235.388-.53.388-.834c0-.593-.57-1.249-1.5-1.249m-1 6.996h2.003V23h-2.004zM12.876 14a6.47 6.47 0 0 0-1.376 4c0 1.509.514 2.897 1.376 4H2v-2a6 6 0 0 1 6-6z"/>
  </svg>
);

// 用户占位符图标
export const UserPlaceholderOutlineIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <path fill="none" stroke="#b3b3b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 15.846c0-1.02.895-1.846 2-1.846s2 .827 2 1.846c0 .368-.116.71-.317.998C20.085 17.7 19 18.519 19 19.538V20m-.01 2H19m-3 0H6.59c-1.545 0-2.774-.752-3.877-1.803c-2.26-2.153 1.45-3.873 2.865-4.715c2.55-1.52 5.628-1.87 8.422-1.054M16.5 6.5a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0" color="#fff"/>
  </svg>
);

// 箭头图标
export const ArrowIcon: React.FC<IconProps> = ({ width = 60, height = 60, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 1024 1024"
    className={className}
    style={style}
  >
    <path 
      fill="#b3b3b3" 
      d="M271.653 1023.192c-8.685 0-17.573-3.432-24.238-10.097c-13.33-13.33-13.33-35.144 0-48.474L703.67 508.163L254.08 58.573c-13.33-13.331-13.33-35.145 0-48.475s35.143-13.33 48.473 0L776.38 483.925c13.33 13.33 13.33 35.143 0 48.473l-480.492 480.694c-6.665 6.665-15.551 10.099-24.236 10.099z"
    />
  </svg>
);

// 问号图标
export const QuestionIcon: React.FC<IconProps> = ({ width = 120, height = 120, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <path 
      fill="none" 
      stroke="#fff" 
      strokeWidth="2" 
      d="M2 3.99C2 2.892 2.898 2 3.99 2h16.02C21.108 2 22 2.898 22 3.99v16.02c0 1.099-.898 1.99-1.99 1.99H3.99A1.995 1.995 0 0 1 2 20.01zM12 15v-1c0-1 0-1.5 1-2s2-1 2-2.5c0-1-1-2.5-3-2.5s-3 1.264-3 3m3 6v2"
    />
  </svg>
);

// 魔法图标（AI制作）
export const MagicIcon: React.FC<IconProps> = ({ width = 36, height = 36, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" color="#fff">
      <path d="M20.998 11q.002.705.002 1.5c0 4.478 0 6.718-1.391 8.109S15.979 22 11.5 22c-4.478 0-6.718 0-8.109-1.391S2 16.979 2 12.5c0-4.478 0-6.718 1.391-8.109S7.021 3 11.5 3q.795 0 1.5.002"/>
      <path d="m18.5 2l.258.697c.338.914.507 1.371.84 1.704c.334.334.791.503 1.705.841L22 5.5l-.697.258c-.914.338-1.371.507-1.704.84c-.334.334-.503.791-.841 1.705L18.5 9l-.258-.697c-.338-.914-.507-1.371-.84-1.704c-.334-.334-.791-.503-1.705-.841L15 5.5l.697-.258c.914-.338 1.371-.507 1.704-.84c.334-.334.503-.791.841-1.705zm-14 19.5c4.372-5.225 9.274-12.116 16.498-7.458"/>
    </g>
  </svg>
);

// 刷新图标
export const RefreshIcon: React.FC<IconProps> = ({ width = 20, height = 20, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 512 512"
    className={className}
    style={style}
  >
    <path 
      fill="none" 
      stroke="#fff" 
      strokeLinecap="round" 
      strokeMiterlimit="10" 
      strokeWidth="32" 
      d="m400 148l-21.12-24.57A191.43 191.43 0 0 0 240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 0 0 181.07-128"
    />
    <path
      className='filled'
      fill="#fff" 
      d="M464 97.42V208a16 16 0 0 1-16 16H337.42c-14.26 0-21.4-17.23-11.32-27.31L436.69 86.1C446.77 76 464 83.16 464 97.42"
    />
  </svg>
);

// 相机图标
export const CameraIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <path 
      d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <circle 
      cx="12" 
      cy="13" 
      r="4" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// AI大脑图标
export const AIBrainIcon: React.FC<IconProps> = ({ width = 90, height = 80, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 576 512"
    className={className}
    style={style}
  >
    <path 
      fill="#fff" 
      d="M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6l75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84l92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1l65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9.1-37.2-11.7l-53.1-76l-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4l-89.6 24.1c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8l-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3l23.9-89.6C260.8 9.7 273.5 0 288 0m0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7l7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6l16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1l17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5l10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2l-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8l-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8l-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8l-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
    />
  </svg>
);

// 重试图标（用于相机界面）
export const RetryIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 32 32"
    className={className}
    style={style}
  >
    <path 
      fill="#fff" 
      d="M18 28A12 12 0 1 0 6 16v6.2l-3.6-3.6L1 20l6 6l6-6l-1.4-1.4L8 22.2V16a10 10 0 1 1 10 10Z"
    />
  </svg>
);

// 确认图标
export const CheckIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 16 16"
    className={className}
    style={style}
  >
    <path 
      fill="#fff" 
      fillRule="evenodd" 
      d="m15.12 2.23l-9.79 9.78L.88 7.56L0 8.44l5.33 5.34L16 3.11z"
    />
  </svg>
);

// 成功图标（绿色勾号）
export const SuccessIcon: React.FC<IconProps> = ({ width = 64, height = 64, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <path 
      fill="#4CAF50" 
      d="M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59z"
    />
  </svg>
);

// 照片图标
export const PhotoIcon: React.FC<IconProps> = ({ width = 60, height = 60, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <g fill="none" stroke="#00bcd4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" color="#00bcd4">
      <path d="M2.5 12c0-4.478 0-6.718 1.391-8.109S7.521 2.5 12 2.5c4.478 0 6.718 0 8.109 1.391S21.5 7.521 21.5 12c0 4.478 0 6.718-1.391 8.109S16.479 21.5 12 21.5c-4.478 0-6.718 0-8.109-1.391S2.5 16.479 2.5 12"/>
      <circle cx="16.5" cy="7.5" r="1.5"/>
      <path d="m2.5 12l1.445-1.445a2.3 2.3 0 0 1 3.404.123l1.992 2.299a1 1 0 0 0 1.318.082l.648-.464a3 3 0 0 1 4.294.77L21.5 21.5"/>
    </g>
  </svg>
);

// 上传图标
export const UploadIcon: React.FC<IconProps> = ({ width = 20, height = 20, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 32 32"
    className={className}
    style={style}
  >
    <path 
      fill="#fff" 
      d="M26 24v4H6v-4H4v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4zm0-10l-1.41-1.41L17 20.17V2h-2v18.17l-7.59-7.58L6 14l10 10z"
    />
  </svg>
);

export const ImageUploadIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" color={style?.color || '#f9818b'}>
      <path fill={style?.color || '#f9818b'} d="M22 6.75a.75.75 0 0 0 0-1.5zm-8-1.5a.75.75 0 0 0 0 1.5zM18.75 2a.75.75 0 0 0-1.5 0zm-1.5 8a.75.75 0 0 0 1.5 0zM22 5.25h-4v1.5h4zm-4 0h-4v1.5h4zM17.25 2v4h1.5V2zm0 4v4h1.5V6z"/><path stroke="#ff6573" d="M11.5 3C7.022 3 4.782 3 3.391 4.391S2 8.021 2 12.5c0 4.478 0 6.718 1.391 8.109S7.021 22 11.5 22c4.478 0 6.718 0 8.109-1.391S21 16.979 21 12.5V12"/>
      <path stroke={style?.color || '#f9818b'} d="M2 14.135q.93-.135 1.872-.132c2.652-.056 5.239.77 7.3 2.331c1.91 1.448 3.253 3.44 3.828 5.666"/>
      <path stroke={style?.color || '#f9818b'} d="M21 16.896c-1.175-.595-2.391-.897-3.614-.896c-1.851-.007-3.684.673-5.386 2"/>
    </g>
  </svg>
);

// 选择图标
export const SelectIcon: React.FC<IconProps> = ({ width = 20, height = 20, className, style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width} 
    height={height} 
    viewBox="0 0 16 16"
    className={className}
    style={style}
  >
    <path 
      fill="#00bcd4" 
      d="M2 3a1 1 0 0 1 1-1h2.5a1 1 0 0 1 0 2H4v1.5a1 1 0 0 1-2 0zm12 0a1 1 0 0 0-1-1h-2.5a1 1 0 1 0 0 2H12v1.5a1 1 0 1 0 2 0zM2 13a1 1 0 0 0 1 1h2.5a1 1 0 1 0 0-2H4v-1.5a1 1 0 1 0-2 0zm12 0a1 1 0 0 1-1 1h-2.5a1 1 0 1 1 0-2H12v-1.5a1 1 0 1 1 2 0z"
    />
  </svg>
);

// 404错误图标
export const NotFoundIcon: React.FC<IconProps> = ({ width = 120, height = 120, className, style }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 14s1.5 2 4 2 4-2 4-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="9" y1="9" x2="9.01" y2="9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="15" y1="9" x2="15.01" y2="9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// 首页图标
export const HomeIcon: React.FC<IconProps> = ({ width = 20, height = 20, className, style }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <path 
      d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <polyline 
      points="9,22 9,12 15,12 15,22" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// 左箭头图标
export const LeftArrowIcon: React.FC<IconProps> = ({ width = 20, height = 20, className, style }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <path 
      d="M15 18L9 12L15 6" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// 打印照片
export const PrintPictureIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <path fill="#fff" d="M16.854 18.462h1.485q-.002.361-.245.617t-.61.317L6.182 20.817q-.671.087-1.2-.325q-.528-.41-.608-1.073l-1.23-9.713q-.08-.672.333-1.216t1.085-.606l.977-.073v1.005l-.823.063q-.27.019-.424.221t-.115.471l1.196 9.713q.039.27.23.424q.193.153.463.115zm-7.7-2q-.69 0-1.153-.463t-.462-1.153V4.616q0-.691.462-1.153T9.154 3h10.23q.691 0 1.153.463T21 4.616v10.23q0 .69-.463 1.153t-1.153.463zm0-1h10.23q.27 0 .443-.173t.173-.443V4.616q0-.27-.173-.443T19.385 4H9.154q-.27 0-.442.173q-.173.173-.173.443v10.23q0 .27.173.443t.442.173m4.967-1.385q1.7 0 2.888-1.175t1.312-2.825q-1.7 0-2.912 1.175t-1.288 2.825m0 0q-.075-1.65-1.287-2.825T9.92 10.077q.125 1.65 1.313 2.825t2.887 1.175m0-3q.425 0 .713-.287t.287-.713v-.25l.25.1q.375.15.763.075t.587-.425q.225-.375.15-.8t-.5-.598l-.25-.098l.25-.099q.425-.173.497-.604q.072-.432-.147-.801q-.206-.356-.571-.437t-.779.087l-.25.1v-.25q0-.425-.287-.712t-.713-.288t-.712.288t-.288.712v.25l-.25-.1q-.413-.17-.779-.088q-.365.082-.57.438q-.22.37-.148.8q.072.432.497.605l.25.099l-.25.098q-.425.173-.5.598t.15.8q.2.35.588.425t.762-.075l.25-.1v.25q0 .425.288.713t.712.287m0-2q-.425 0-.712-.287t-.288-.713t.288-.712t.712-.288t.713.288t.287.712t-.287.713t-.713.287"/>
  </svg>
);

// 打印照片
export const MagicuteIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <g fill="none">
      <path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"/><path fill="#fff" d="M9.107 5.448c.598-1.75 3.016-1.803 3.725-.159l.06.16l.807 2.36a4 4 0 0 0 2.276 2.411l.217.081l2.36.806c1.75.598 1.803 3.016.16 3.725l-.16.06l-2.36.807a4 4 0 0 0-2.412 2.276l-.081.216l-.806 2.361c-.598 1.75-3.016 1.803-3.724.16l-.062-.16l-.806-2.36a4 4 0 0 0-2.276-2.412l-.216-.081l-2.36-.806c-1.751-.598-1.804-3.016-.16-3.724l.16-.062l2.36-.806A4 4 0 0 0 8.22 8.025l.081-.216zM11 6.094l-.806 2.36a6 6 0 0 1-3.49 3.649l-.25.091l-2.36.806l2.36.806a6 6 0 0 1 3.649 3.49l.091.25l.806 2.36l.806-2.36a6 6 0 0 1 3.49-3.649l.25-.09l2.36-.807l-2.36-.806a6 6 0 0 1-3.649-3.49l-.09-.25zM19 2a1 1 0 0 1 .898.56l.048.117l.35 1.026l1.027.35a1 1 0 0 1 .118 1.845l-.118.048l-1.026.35l-.35 1.027a1 1 0 0 1-1.845.117l-.048-.117l-.35-1.026l-1.027-.35a1 1 0 0 1-.118-1.845l.118-.048l1.026-.35l.35-1.027A1 1 0 0 1 19 2"/>
    </g>
  </svg>
);

export const SpinnerIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <circle cx="4" cy="12" r="3" fill="#fff">
      <animate id="svgSpinners3DotsScale0" attributeName="r" begin="0;svgSpinners3DotsScale1.end-0.25s" dur="0.75s" values="3;.2;3"/>
    </circle>
    <circle cx="12" cy="12" r="3" fill="#fff">
      <animate attributeName="r" begin="svgSpinners3DotsScale0.end-0.6s" dur="0.75s" values="3;.2;3"/>
    </circle>
    <circle cx="20" cy="12" r="3" fill="#fff">
      <animate id="svgSpinners3DotsScale1" attributeName="r" begin="svgSpinners3DotsScale0.end-0.45s" dur="0.75s" values="3;.2;3"/>
    </circle>
  </svg>
);

export const CloseIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
      <path d="M5 12H19">
        <animate fill="freeze" attributeName="d" dur="0.4s" values="M5 12H19;M12 12H12"/>
        <set fill="freeze" attributeName="opacity" begin="0.4s" to="0"/>
      </path>
      <path d="M5 5L19 5M5 19L19 19" opacity="0">
        <animate fill="freeze" attributeName="d" begin="0.2s" dur="0.4s" values="M5 5L19 5M5 19L19 19;M5 5L19 19M5 19L19 5"/>
        <set fill="freeze" attributeName="opacity" begin="0.2s" to="1"/>
      </path>
    </g>
  </svg>
);

export const ThreeDIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 56 56"
    className={className}
    style={style}
  >
    <path fill="#fff" d="M7.328 43.504c.445 0 .914-.14 1.383-.469V17.957c0-.844.164-1.172.914-1.57L31.352 3.87c.07-1.547-.915-2.508-2.25-2.508c-.61 0-1.266.164-1.97.586L7.493 13.246c-2.297 1.336-2.578 1.758-2.578 4.43v22.43c0 2.015.96 3.398 2.414 3.398m9.375 5.414c.422 0 .89-.14 1.383-.469V23.371c0-.914.117-1.148.89-1.57L40.703 9.26c.07-1.523-.89-2.507-2.25-2.507c-.586 0-1.266.187-1.945.562L16.82 18.636c-2.297 1.313-2.555 1.805-2.555 4.43V45.52c0 2.015 1.008 3.398 2.438 3.398m10.031 5.719c.82 0 1.805-.328 2.977-.985l18.375-10.547c2.156-1.242 3-2.53 3-5.156l-.047-21.234c0-2.813-1.008-4.242-2.766-4.242c-.773 0-1.758.304-2.859.937L26.992 24.027c-2.203 1.29-2.977 2.602-2.977 5.157v21.234c0 2.719.961 4.219 2.72 4.219M28 50.067c-.117-.024-.164-.094-.164-.258L28 29.254c0-.89.258-1.36 1.055-1.805l17.742-10.43c.07-.046.14-.046.234-.023c.094.024.164.094.164.258l-.07 20.625c0 .773-.281 1.36-1.055 1.828L28.234 50.043a.28.28 0 0 1-.234.023"/>
  </svg>
);

export const DisconnectedIcon: React.FC<IconProps> = ({ width = 24, height = 24, className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <g fill="none" stroke={style?.color || "#fff"} strokeLinecap="round" strokeWidth="1.5">
      <path strokeLinejoin="round" d="M8.5 16c.867-.867 1.92-1.358 3-1.474m-6-2.026c3.173-3.173 7.122-3.83 10.5-1.968M2 8.5c6.316-5.333 13.684-5.333 20 0"/>
      <path d="m21 13.5l-6 6m6 0l-6-6"/>
    </g>
  </svg>
);
